'use strict';

var errors = {
  SCRIPT_LOAD: {
    src: 79,
    eventId: 104,
    params: {
      app_id: 'app_id',
      script_name: 'script_name',
      script_url: 'script_url',
      time_spent: 'time_spent',
      error: 'error'
    }
  },
  INIT_APP_FOR_PAGE: {
    src: 79,
    eventId: 106,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      error: 'error'
    }
  },
  CREATE_CONTROLLERS: {
    src: 79,
    eventId: 108,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      time_spent: 'time_spent',
      error: 'error'
    }
  },
  PAGE_READY: {
    src: 79,
    eventId: 111,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      controller_type: 'controller_type',
      error: 'error'
    }
  },
  PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION: {
    errorName: 'PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION',
    errorCode: 111033,
    severity: 'error',
    params: {
      errorMsg: 'errorMsg',
      stack: 'stack',
      line: 'line',
      column: 'column'
    }
  }
};

module.exports = errors;



// WEBPACK FOOTER //
// ./src/main/errors.js